import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { ArticleStatus } from "@domain/lms/article/article";
import { articleStatusColor } from "@ui/styles/colors";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";

interface ArticleStatusLabelProps extends React.HTMLAttributes<HTMLDivElement> {
	status: ArticleStatus;
}
export const ArticleStatusLabel: React.FC<ArticleStatusLabelProps> = ({ status, ...htmlProps }) => {
	return (
		<Container status={status} {...htmlProps}>
			• {I18n.t(`article.status.${status}`)}
		</Container>
	);
};

const Container = styled(RoundedBlock)<{ status: ArticleStatus }>`
	padding: 5px 10px;
	border-radius: 15px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ status }) => articleStatusColor[status]};
	text-align: center;
`;
